/**
 * API base URL. In dev, Vite proxy handles /api/* and /super/api/*.
 * In production, calls go directly to the Worker.
 */
export const API_BASE = import.meta.env.DEV
  ? ""
  : "https://platform-worker.ahava-shop.workers.dev";

/** Build a full API URL */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

/**
 * Install a global fetch interceptor that rewrites /api/* and /super/api/*
 * requests to the Worker URL in production. Call once at app startup.
 */
let interceptorInstalled = false;

export function installApiInterceptor(): void {
  if (import.meta.env.DEV || !API_BASE || interceptorInstalled) return;
  interceptorInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    if (typeof input === "string") {
      if (input.startsWith("/api/") || input.startsWith("/super/api/")) {
        return originalFetch(`${API_BASE}${input}`, init);
      }
    }
    return originalFetch(input, init);
  };
}
